import { Component, OnInit } from '@angular/core';
import { Notifications } from '../../../providers/notifications';
import { Router } from '@angular/router';
import { Globals } from '../../../globals';
import { MemberFirebaseService } from 'app/services/member/member.firebase.service';
import { User } from 'app/core/user';
import { MaintenanceFirebaseService } from 'app/services/maintenance/maintenance.firebase.service';
import { AngularFirestore } from 'angularfire2/firestore';
import { DBContextFirebaseService } from 'app/services/db-context/db-context.firebase.service';
import { DateFormatting } from 'app/providers/date-formatting';
import swal from 'sweetalert2';
import * as firebase from 'firebase'

declare var $: any;

interface PatientCalCount {
    userUid: string;
    educatorVisitCount: number;
}

interface DNEVisitCount {
    visit1: number;
    visit2: number;
    visit3: number;
    visit4: number;
    visit5: number;
    visit6: number;
    total: number;
}

interface MetricAverageCount {
    visit1: number;
    visit1Total: number;
    visit1TotalUsers: number;
    visit2: number;
    visit2Total: number;
    visit2TotalUsers: number;
    visit3Total: number;
    visit3: number;
    visit3TotalUsers: number;
    visit4Total: number;
    visit4: number;
    visit4TotalUsers: number;
    visit5Total: number;
    visit5: number;
    visit5TotalUsers: number;
    visit6Total: number;
    visit6: number;
    visit6TotalUsers: number;
}

interface UsersObject {
    uid?: string;
    dateUpdated?: firebase.firestore.Timestamp;
    straussDetails?: UsersList;
    lubbeDetails?: UsersList;
    dembskeyDetails?: UsersList;
    makanDetails?: UsersList;
    kokDetails?: UsersList;
    vanNiekerkDetails?: UsersList;
    plantDetails?: UsersList;
    redpathDetails?: UsersList;
    labuschagneDetails?: UsersList;
}


interface UsersList {
    userDetails: User;
    userPatients: User[];
    userPatientsUnder18: number;
    userPatients18to35: number;
    userPatients36to50: number;
    userPatientsOver50: number;
    userPatientsMale?: number;
    userPatientsFemale?: number;
    userPatientsEducatorCalendars?: PatientCalCount[];
    userDNEVisitCount?: DNEVisitCount;
    userHba1cTestCount?: number;
    userLipogramTestCount?: number;
    averageHba1c?: MetricAverageCount;
    averageLDL?: MetricAverageCount;
    averageCholesterol?: MetricAverageCount;
    averageHDL?: MetricAverageCount;
    averageMAUARC?: MetricAverageCount;
    averageTriglycerides?: MetricAverageCount;
    averageWaistCircumference?: MetricAverageCount;
    averageWeightBmi?: MetricAverageCount;
    averageSystolic?: MetricAverageCount;
    averageDiastolic?: MetricAverageCount;
}

@Component({
    selector: 'app-admin-general-report-1-cmp',
    templateUrl: './admin-general-report-1.component.html',
    styleUrls: ['./admin-general-report-1.component.css']

})

export class AdminGeneralReport1Component implements OnInit {

    usersObject: UsersObject = {};
    lastUpdated = 'Never'
    completioncount = 0;
    regenerating = false;

    // straussDetails: UsersList;
    // lubbeDetails: UsersList;
    // dembskeyDetails: UsersList;
    // makanDetails: UsersList;
    // kokDetails: UsersList;
    // vanNiekerkDetails: UsersList;
    // plantDetails: UsersList;
    // redpathDetails: UsersList;
    // labuschagneDetails: UsersList;


    constructor(
        public n: Notifications
        , public router: Router
        , public df: DateFormatting
        , public gb: Globals
        , private afDB: AngularFirestore
        , public memberFirebaseService: MemberFirebaseService
        , public maintenanceFirebaseService: MaintenanceFirebaseService,
        private dBContextFirebaseService: DBContextFirebaseService

    ) { }

    async ngOnInit() {
        this.gb.loggedInUser = this.gb.getLoggedInUser()
        await this.getSavedReport();

        if (!this.usersObject.dateUpdated) {
            this.regenerating = true;
        } else {
            this.lastUpdated = this.df.formatDateToStringYYYMMDD(this.usersObject.dateUpdated.toDate())
            this.regenerating = false;
        }
        await this.getUsers();

    }

    async getSavedReport() {
        await this.afDB.firestore
            .collection('reports')
            .get()
            .then(querySnapShot => {
                if (querySnapShot && querySnapShot.docs.length > 0) {
                    this.usersObject = querySnapShot.docs[0].data()
                    console.log('Report Retrieved')
                    console.log(this.usersObject)
                }
            })
    }

    regenReport() {
        swal({
            title: 'Are you sure?',
            text: 'Generating this report will take some time',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
        }).then((result) => {
            this.completioncount = 0;
            if (!result.dismiss) {
                swal({
                    title: 'Generating Report, Please be patient.',
                    text: 'This will take about 10 minutes, please leave this page open',
                    type: 'success',
                    confirmButtonText: 'Ok',
                })
                this.regenerating = true;
                const uid = this.usersObject.uid;
                this.usersObject = {};
                this.usersObject.uid = uid;
                this.getUsers();
            }
        })
    }

    async getUsers() {
        this.maintenanceFirebaseService.getUserDetailsByEmail('lindiestrauss@yahoo.com').then(async data => {
            this.usersObject.straussDetails = await this.setDetails(data, this.usersObject.straussDetails)
            this.completionStatus();
        })
        this.maintenanceFirebaseService.getUserDetailsByEmail('lubbejacqueline@gmail.com').then(async data => {
            this.usersObject.lubbeDetails = await this.setDetails(data, this.usersObject.lubbeDetails)
            this.completionStatus();
        })
        this.maintenanceFirebaseService.getUserDetailsByEmail('jdembskey@gmail.com').then(async data => {
            this.usersObject.dembskeyDetails = await this.setDetails(data, this.usersObject.dembskeyDetails)
            this.completionStatus();
        })
        this.maintenanceFirebaseService.getUserDetailsByEmail('h.makan@megaweb.co.za').then(async data => {
            this.usersObject.makanDetails = await this.setDetails(data, this.usersObject.makanDetails)
            this.completionStatus();
        })
        this.maintenanceFirebaseService.getUserDetailsByEmail('adri@drjakok.co.za').then(async data => {
            this.usersObject.kokDetails = await this.setDetails(data, this.usersObject.kokDetails)
            this.completionStatus();
        })
        this.maintenanceFirebaseService.getUserDetailsByEmail('drvanniekerk@mulbartongps.co.za').then(async data => {
            this.usersObject.vanNiekerkDetails = await this.setDetails(data, this.usersObject.vanNiekerkDetails)
            this.completionStatus();
        })
        this.maintenanceFirebaseService.getUserDetailsByEmail('ferreiraplant@bitcc.co.za').then(async data => {
            this.usersObject.plantDetails = await this.setDetails(data, this.usersObject.plantDetails)
            this.completionStatus();
        })
        this.maintenanceFirebaseService.getUserDetailsByEmail('redpathheila@gmail.com').then(async data => {
            this.usersObject.redpathDetails = await this.setDetails(data, this.usersObject.redpathDetails)
            this.completionStatus();
        })
        this.maintenanceFirebaseService.getUserDetailsByEmail('docjan911@gmail.com').then(async data => {
            this.usersObject.labuschagneDetails = await this.setDetails(data, this.usersObject.labuschagneDetails)
            this.completionStatus();
        })
    }

    completionStatus() {
        if (this.regenerating) {

            this.completioncount += 1;

            if (this.completioncount === 4) {
                swal({
                    position: 'top-end',
                    type: 'success',
                    title: '4 of 9 users processed',
                    showConfirmButton: false,
                    timer: 1500
                })
            }

            if (this.completioncount === 7) {
                swal({
                    position: 'top-end',
                    type: 'success',
                    title: '7 of 9 users processed',
                    showConfirmButton: false,
                    timer: 1500
                })
            }

            if (this.completioncount === 8) {
                swal({
                    position: 'top-end',
                    type: 'success',
                    title: '8 of 9 users processed',
                    showConfirmButton: false,
                    timer: 1500
                })
            }

            if (this.completioncount === 9) {
                swal({
                    title: 'Completed',
                    text: 'Report Generated',
                    type: 'success',
                    confirmButtonText: 'Ok',
                })
                this.saveResults();
            }

        }


    }

    refresh(): void {
        window.location.reload();
    }

    async setDetails(user: User, oldUserList: UsersList): Promise<UsersList> {
        const userPatients = await this.memberFirebaseService.getUserMembers(user)
        const userPatientsEducatorCalendars = await this.memberFirebaseService.getUserMemberDEducatorCalendars(userPatients)
        const userPatientsMale = userPatients.filter(x => x.gender === 'male').length
        const userPatientsFemale = userPatients.filter(x => x.gender === 'female').length
        const userPatientsUnder18 = (userPatients.filter(x => {
            this.filterAgeUnder18(x.dateOfBirth, x)
        })).length
        const userPatients18to35 = (userPatients.filter(x => {
            this.filterAge18to35(x.dateOfBirth, x)
        })).length
        const userPatients36to50 = (userPatients.filter(x => {
            this.filterAge36to50(x.dateOfBirth, x)
        })).length
        const userPatientsOver50 = (userPatients.filter(x => {
            this.filterAgeOver50(x.dateOfBirth, x)
        })).length

        const returnObje: UsersList = {
            userDetails: user,
            userPatients: userPatients,
            userPatientsEducatorCalendars: userPatientsEducatorCalendars,
            userPatientsMale: userPatientsMale,
            userPatientsFemale: userPatientsFemale,
            userPatientsUnder18: userPatientsUnder18,
            userPatients18to35: userPatients18to35,
            userPatients36to50: userPatients36to50,
            userPatientsOver50: userPatientsOver50
        }

        if (!this.regenerating) {
            returnObje.userDNEVisitCount = oldUserList.userDNEVisitCount;
            returnObje.userHba1cTestCount = oldUserList.userHba1cTestCount
            returnObje.userLipogramTestCount = oldUserList.userLipogramTestCount
            returnObje.averageHba1c = oldUserList.averageHba1c
            returnObje.averageLDL = oldUserList.averageLDL
            returnObje.averageCholesterol = oldUserList.averageCholesterol
            returnObje.averageHDL = oldUserList.averageHDL
            returnObje.averageMAUARC = oldUserList.averageMAUARC
            returnObje.averageTriglycerides = oldUserList.averageTriglycerides
            returnObje.averageWaistCircumference = oldUserList.averageWaistCircumference
            returnObje.averageWeightBmi = oldUserList.averageWeightBmi
            returnObje.averageDiastolic = oldUserList.averageDiastolic
            returnObje.averageSystolic = oldUserList.averageSystolic
        } else {
            returnObje.userDNEVisitCount = await this.getPatientDNECount(userPatients)
            returnObje.userHba1cTestCount = await this.getPatientMetricsCount('HbA1c Test', userPatients)
            returnObje.userLipogramTestCount = await this.getPatientMetricsCount('Lipogram Test', userPatients)
            returnObje.averageHba1c = await this.getStandardMetric('HbA1c', userPatients)
            returnObje.averageLDL = await this.getStandardMetric('LDL', userPatients)
            returnObje.averageCholesterol = await this.getStandardMetric('Cholesterol', userPatients)
            returnObje.averageHDL = await this.getStandardMetric('HDL', userPatients)
            returnObje.averageMAUARC = await this.getStandardMetric('MAUARC', userPatients)
            returnObje.averageTriglycerides = await this.getStandardMetric('Triglycerides', userPatients)
            returnObje.averageWaistCircumference = await this.getStandardMetric('WaistCircumference', userPatients)
            returnObje.averageWeightBmi = await this.getStandardMetric('WeightBmi', userPatients)
            returnObje.averageDiastolic = await this.getStandardMetric('Bloodpressure', userPatients, true, false)
            returnObje.averageSystolic = await this.getStandardMetric('Bloodpressure', userPatients, true, true)
        }
        return returnObje;
    }


    roundDecimals(number: number) {
        if (number) {
            return Math.round(number * 100) / 100
        } else {
            return 0;
        }
    }

    async getPatientMetricsCount(metric: string, patients: User[]): Promise<number> {

        console.log('Getting Metrics Count')

        let returnAmount = 0;

        for (let index = 0; index < patients.length; index++) {

            const patient = patients[index];

            // if (patient.email === 'zaryindustries@gmail.com') {

            const querySnapshot = await this.afDB.firestore
                .collection('users')
                .doc(patient.uid)
                .collection('events')
                .where('service', '==', metric)
                .get()

            returnAmount += querySnapshot.docs.length;
        }
        return returnAmount
    }

    async getStandardMetric(collectionName: string, patients: User[], isBloodPressure = false,
        isSystolic = false): Promise<MetricAverageCount> {
        const returnMetricAverageCount: MetricAverageCount = {
            visit1: 0,
            visit2: 0,
            visit3: 0,
            visit4: 0,
            visit5: 0,
            visit6: 0,
            visit1Total: 0,
            visit2Total: 0,
            visit3Total: 0,
            visit4Total: 0,
            visit5Total: 0,
            visit6Total: 0,
            visit1TotalUsers: 0,
            visit2TotalUsers: 0,
            visit3TotalUsers: 0,
            visit4TotalUsers: 0,
            visit5TotalUsers: 0,
            visit6TotalUsers: 0,
        }

        for (let index = 0; index < patients.length; index++) {

            const patient = patients[index];

            const querySnapshot = await this.afDB.firestore
                .collection('users')
                .doc(patient.uid)
                .collection(collectionName)
                .orderBy('date', 'asc')
                .get()

            try {

                try {
                    if (querySnapshot.docs.length > 0) {
                        returnMetricAverageCount.visit1TotalUsers++;
                        returnMetricAverageCount.visit1Total += this.getReading(isBloodPressure, isSystolic, querySnapshot, 0)
                    }
                    if (querySnapshot.docs.length > 1) {
                        returnMetricAverageCount.visit2TotalUsers++;
                        returnMetricAverageCount.visit2Total += this.getReading(isBloodPressure, isSystolic, querySnapshot, 1)
                    }
                    if (querySnapshot.docs.length > 2) {
                        returnMetricAverageCount.visit3TotalUsers++;
                        returnMetricAverageCount.visit3Total += this.getReading(isBloodPressure, isSystolic, querySnapshot, 2)
                    }
                    if (querySnapshot.docs.length > 3) {
                        returnMetricAverageCount.visit4TotalUsers++;
                        returnMetricAverageCount.visit4Total += this.getReading(isBloodPressure, isSystolic, querySnapshot, 3)
                    }
                    if (querySnapshot.docs.length > 4) {
                        returnMetricAverageCount.visit5TotalUsers++;
                        returnMetricAverageCount.visit5Total += this.getReading(isBloodPressure, isSystolic, querySnapshot, 4)
                    }
                    if (querySnapshot.docs.length > 5) {
                        returnMetricAverageCount.visit6TotalUsers++;
                        returnMetricAverageCount.visit6Total += this.getReading(isBloodPressure, isSystolic, querySnapshot, 5)
                    }
                } catch (error) {
                    console.log(error)
                }
            } catch (error) {
                console.log(error)
            }
        }

        returnMetricAverageCount.visit1 = returnMetricAverageCount.visit1Total / returnMetricAverageCount.visit1TotalUsers;
        returnMetricAverageCount.visit2 = returnMetricAverageCount.visit2Total / returnMetricAverageCount.visit2TotalUsers;
        returnMetricAverageCount.visit3 = returnMetricAverageCount.visit3Total / returnMetricAverageCount.visit3TotalUsers;
        returnMetricAverageCount.visit4 = returnMetricAverageCount.visit4Total / returnMetricAverageCount.visit4TotalUsers;
        returnMetricAverageCount.visit5 = returnMetricAverageCount.visit5Total / returnMetricAverageCount.visit5TotalUsers;
        returnMetricAverageCount.visit6 = returnMetricAverageCount.visit6Total / returnMetricAverageCount.visit6TotalUsers;


        if (returnMetricAverageCount.visit1) {
            returnMetricAverageCount.visit1 = Math.round(returnMetricAverageCount.visit1 * 100) / 100
        } else {
            returnMetricAverageCount.visit1 = 0
        }
        if (returnMetricAverageCount.visit2) {
            returnMetricAverageCount.visit2 = Math.round(returnMetricAverageCount.visit2 * 100) / 100
        } else {
            returnMetricAverageCount.visit2 = 0
        }
        if (returnMetricAverageCount.visit3) {
            returnMetricAverageCount.visit3 = Math.round(returnMetricAverageCount.visit3 * 100) / 100
        } else {
            returnMetricAverageCount.visit3 = 0
        }
        if (returnMetricAverageCount.visit4) {
            returnMetricAverageCount.visit4 = Math.round(returnMetricAverageCount.visit4 * 100) / 100
        } else {
            returnMetricAverageCount.visit4 = 0
        }
        if (returnMetricAverageCount.visit5) {
            returnMetricAverageCount.visit5 = Math.round(returnMetricAverageCount.visit5 * 100) / 100
        } else {
            returnMetricAverageCount.visit5 = 0
        }
        if (returnMetricAverageCount.visit6) {
            returnMetricAverageCount.visit6 = Math.round(returnMetricAverageCount.visit6 * 100) / 100
        } else {
            returnMetricAverageCount.visit6 = 0
        }
        return returnMetricAverageCount
    }


    getReading(isBloodPressure, isSystolic, querySnapshot, count) {
        if (isBloodPressure && isSystolic) {
            return querySnapshot.docs[count].data().upperReading

        } else if (isBloodPressure && !isSystolic) {
            return querySnapshot.docs[count].data().lowerReading

        } else {
            return querySnapshot.docs[count].data().reading
        }
    }


    async getPatientDNECount(patients: User[]): Promise<DNEVisitCount> {

        console.log('Getting DNE Count')

        const dneVisitCount: DNEVisitCount = {
            visit1: 0,
            visit2: 0,
            visit3: 0,
            visit4: 0,
            visit5: 0,
            visit6: 0,
            total: 0
        }

        for (let index = 0; index < patients.length; index++) {

            const patient = patients[index];

            // if (patient.email === 'zaryindustries@gmail.com') {

            const querySnapshot = await this.afDB.firestore
                .collection('users')
                .doc(patient.uid)
                .collection('events')
                .orderBy('date', 'asc')
                .where('service', '==', 'Diabetes Educator Consultation')
                .get()

            try {
                if (querySnapshot.docs.length > 0) {
                    dneVisitCount.visit1++;
                    dneVisitCount.total++;
                }
                if (querySnapshot.docs.length > 1) {
                    dneVisitCount.visit2++;
                    dneVisitCount.total++;
                }
                if (querySnapshot.docs.length > 2) {
                    dneVisitCount.visit3++;
                    dneVisitCount.total++;
                }
                if (querySnapshot.docs.length > 3) {
                    dneVisitCount.visit4++;
                    dneVisitCount.total++;
                }
                if (querySnapshot.docs.length > 4) {
                    dneVisitCount.visit5++;
                    dneVisitCount.total++;
                }
                if (querySnapshot.docs.length > 5) {
                    dneVisitCount.visit6++;
                    dneVisitCount.total++;
                }
            } catch (error) {
                console.log(error)
            }
        }

        return dneVisitCount
    }

    filterAgeUnder18(dateOfBirth: Date, user: User): any {
        const currAge = this.gb.currentAge(dateOfBirth)
        if (currAge !== 0) {
            if (currAge < 18) {
                return user;
            }
        } else {
            return;
        }
    }

    filterAge18to35(dateOfBirth: Date, user: User): any {
        const currAge = this.gb.currentAge(dateOfBirth)
        if (currAge !== 0) {
            if (currAge >= 18 && currAge <= 35) {
                return user;
            }
        } else {
            return;
        }
    }


    filterAge36to50(dateOfBirth: Date, user: User): any {
        const currAge = this.gb.currentAge(dateOfBirth)
        if (currAge !== 0) {
            if (currAge >= 36 && currAge <= 50) {
                return user;
            }
        } else {
            return;
        }
    }

    filterAgeOver50(dateOfBirth: Date, user: User): any {
        const currAge = this.gb.currentAge(dateOfBirth)
        if (currAge !== 0) {
            if (currAge > 50) {
                return user;
            }
        } else {
            return;
        }
    }

    saveResults() {

        console.log(this.usersObject)
        console.log(this.usersObject)
        console.log(this.usersObject)
        console.log(this.usersObject)
        console.log(this.usersObject)
        console.log(this.usersObject)


        try {
            delete this.usersObject.dembskeyDetails.userDetails
            delete this.usersObject.dembskeyDetails.userPatients
            delete this.usersObject.dembskeyDetails.userPatientsEducatorCalendars
            delete this.usersObject.dembskeyDetails.userPatientsMale
            delete this.usersObject.dembskeyDetails.userPatientsFemale
            delete this.usersObject.dembskeyDetails.userPatientsUnder18
            delete this.usersObject.dembskeyDetails.userPatients18to35
            delete this.usersObject.dembskeyDetails.userPatients36to50
            delete this.usersObject.dembskeyDetails.userPatientsOver50
        } catch (error) {

        }


        try {
            delete this.usersObject.kokDetails.userDetails
            delete this.usersObject.kokDetails.userPatients
            delete this.usersObject.kokDetails.userPatientsEducatorCalendars
            delete this.usersObject.kokDetails.userPatientsMale
            delete this.usersObject.kokDetails.userPatientsFemale
            delete this.usersObject.kokDetails.userPatientsUnder18
            delete this.usersObject.kokDetails.userPatients18to35
            delete this.usersObject.kokDetails.userPatients36to50
            delete this.usersObject.kokDetails.userPatientsOver50
        } catch (error) {

        }

        try {

            delete this.usersObject.lubbeDetails.userDetails
            delete this.usersObject.lubbeDetails.userPatients
            delete this.usersObject.lubbeDetails.userPatientsEducatorCalendars
            delete this.usersObject.lubbeDetails.userPatientsMale
            delete this.usersObject.lubbeDetails.userPatientsFemale
            delete this.usersObject.lubbeDetails.userPatientsUnder18
            delete this.usersObject.lubbeDetails.userPatients18to35
            delete this.usersObject.lubbeDetails.userPatients36to50
            delete this.usersObject.lubbeDetails.userPatientsOver50
        } catch (error) {

        }

        try {
            delete this.usersObject.makanDetails.userDetails
            delete this.usersObject.makanDetails.userPatients
            delete this.usersObject.makanDetails.userPatientsEducatorCalendars
            delete this.usersObject.makanDetails.userPatientsMale
            delete this.usersObject.makanDetails.userPatientsFemale
            delete this.usersObject.makanDetails.userPatientsUnder18
            delete this.usersObject.makanDetails.userPatients18to35
            delete this.usersObject.makanDetails.userPatients36to50
            delete this.usersObject.makanDetails.userPatientsOver50
        } catch (error) {

        }

        try {
            delete this.usersObject.plantDetails.userDetails
            delete this.usersObject.plantDetails.userPatients
            delete this.usersObject.plantDetails.userPatientsEducatorCalendars
            delete this.usersObject.plantDetails.userPatientsMale
            delete this.usersObject.plantDetails.userPatientsFemale
            delete this.usersObject.plantDetails.userPatientsUnder18
            delete this.usersObject.plantDetails.userPatients18to35
            delete this.usersObject.plantDetails.userPatients36to50
            delete this.usersObject.plantDetails.userPatientsOver50

        } catch (error) {

        }

        try {
            delete this.usersObject.redpathDetails.userDetails
            delete this.usersObject.redpathDetails.userPatients
            delete this.usersObject.redpathDetails.userPatientsEducatorCalendars
            delete this.usersObject.redpathDetails.userPatientsMale
            delete this.usersObject.redpathDetails.userPatientsFemale
            delete this.usersObject.redpathDetails.userPatientsUnder18
            delete this.usersObject.redpathDetails.userPatients18to35
            delete this.usersObject.redpathDetails.userPatients36to50
            delete this.usersObject.redpathDetails.userPatientsOver50
        } catch (error) {

        }

        try {
            delete this.usersObject.straussDetails.userDetails
            delete this.usersObject.straussDetails.userPatients
            delete this.usersObject.straussDetails.userPatientsEducatorCalendars
            delete this.usersObject.straussDetails.userPatientsMale
            delete this.usersObject.straussDetails.userPatientsFemale
            delete this.usersObject.straussDetails.userPatientsUnder18
            delete this.usersObject.straussDetails.userPatients18to35
            delete this.usersObject.straussDetails.userPatients36to50
            delete this.usersObject.straussDetails.userPatientsOver50
        } catch (error) {

        }

        try {
            delete this.usersObject.vanNiekerkDetails.userDetails
            delete this.usersObject.vanNiekerkDetails.userPatients
            delete this.usersObject.vanNiekerkDetails.userPatientsEducatorCalendars
            delete this.usersObject.vanNiekerkDetails.userPatientsMale
            delete this.usersObject.vanNiekerkDetails.userPatientsFemale
            delete this.usersObject.vanNiekerkDetails.userPatientsUnder18
            delete this.usersObject.vanNiekerkDetails.userPatients18to35
            delete this.usersObject.vanNiekerkDetails.userPatients36to50
            delete this.usersObject.vanNiekerkDetails.userPatientsOver50
        } catch (error) {

        }

        try {
            delete this.usersObject.labuschagneDetails.userDetails
            delete this.usersObject.labuschagneDetails.userPatients
            delete this.usersObject.labuschagneDetails.userPatientsEducatorCalendars
            delete this.usersObject.labuschagneDetails.userPatientsMale
            delete this.usersObject.labuschagneDetails.userPatientsFemale
            delete this.usersObject.labuschagneDetails.userPatientsUnder18
            delete this.usersObject.labuschagneDetails.userPatients18to35
            delete this.usersObject.labuschagneDetails.userPatients36to50
            delete this.usersObject.labuschagneDetails.userPatientsOver50
        } catch (error) {

        }

        const collection = this.afDB.collection('reports')
        this.dBContextFirebaseService.set(this.usersObject, collection).catch(error => {
            console.log(error)
        }).then(async data => {
            console.log('Getting saved Report')
            this.refresh();
        })
    }
}
